module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAAXUlEQVQ4y2P8//8/AzUBEwOVwcAYyNjJ8J+xk8FhBHl5eBnIiJywGTsZyErl/8sZGGFsFjQ5Rxx69jMwMBQyMDBcIGz6//8EMUPH//8MHf8diFE7mmwGezocGV4GANJPSsgIAd1aAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/dataGrid/icon_add_1.png
// module id = 1149
// module chunks = 50